import './main.css'
import { useEffect, useState } from 'react';
import createPaymentLink from '../createCheckout/main';
import callAPI from '../fetch/main';
import { Descriptions, Progress, Row, Col, Button, Divider, Switch, Radio, Tooltip, Collapse, message, Alert, Badge, Table, Tag, Flex, Modal, Popover, Card } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CrownOutlined, DashboardOutlined, ExperimentOutlined, FireFilled, FireOutlined, RightCircleFilled, RiseOutlined, SafetyCertificateFilled, SafetyOutlined, StockOutlined, UserOutlined, CopyOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import Underline from '@tiptap/extension-underline';
import NewYearSaleBanner from '../newYearSaleBanner/main';


// Assume this is calculated outside or inside your component
function getRenewalInfo(startDate, monthsToAdd) {
    const start = dayjs(startDate);
    const renewalDate = start.add(monthsToAdd, 'month');
    const daysUntilRenewal = renewalDate.diff(dayjs(), 'day');
    return {
        daysUntilRenewal,
        nextRenewalDate: renewalDate.format('D MMM YYYY'),
    };
}
const getMonthsFromBilling = (billingText = "") => {
    const lower = billingText.toLowerCase();
    if (lower.includes("quarter")) return 3;
    if (lower.includes("two")) return 2;
    if (lower.includes("2")) return 2;
    if (lower.includes("bi")) return 2;
    if (lower.includes("semi")) return 6;
    if (lower.includes("annual") || lower.includes("year")) return 12;
    return 1;
};


function splitAmountPerDay(amountWithSymbol, days) {
    if (!amountWithSymbol || !days || days <= 0) return null;

    const match = amountWithSymbol.match(/^(\D*)([\d.,]+)/);
    if (!match) return null;

    const symbol = match[1];
    const amount = parseFloat(match[2].replace(/,/g, '')); // Handles comma in ₹1,398

    if (isNaN(amount)) return null;

    const perDay = (amount / days).toFixed(2);
    return `${symbol}${perDay} per Day`;
}


function Coupons({ showINR }) {


    let cpns = {
        "usd": [
            { "name": "Legend Yearly", "value": "Extra $20", "description": "Offer for 1st year on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSER", "expires": "31-DEC-2024" },
            { "name": "Legend Monthly", "value": "Extra $2", "description": "Offer every month for next 3 month on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSERMON", "expires": "31-DEC-2024" },
            { "name": "Growth Yearly", "value": "Get Extra 10%", "description": "Offer for 1st year on growth yearly plan, Only for beta users.", "code": "GROWTHBETAUSER", "expires": "31-DEC-2024" },
        ],

        "inr": [
            { "name": "Legend Yearly", "value": "Extra ₹1,600*", "description": "Offer for 1st year on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSER", "expires": "31-DEC-2024" },
            { "name": "Legend Monthly", "value": "Extra ₹160*", "description": "Offer every month for next 3 month on legend yearly plan, Only for beta users.", "code": "LEGENDBETAUSERMON", "expires": "31-DEC-2024" },
            { "name": "Growth Yearly", "value": "Get Extra 10%", "description": "offer for 1st year on growth yearly plan, Only for beta users.", "code": "GROWTHBETAUSER", "expires": "31-DEC-2024" },
        ]
    }


    return (
        <div>
            <h3 style={{ fontWeight: '500' }}>Offers only for Beta users:</h3>
            <div className='coupons-list'>
                {
                    cpns[showINR ? "inr" : "usd"].map((cpn) =>
                        <div className='coupon'>
                            <div className='coupon-header'>
                                <p>{cpn.name}</p>
                            </div>
                            <div className='coupon-body'>
                                <div className='price-n-code'>
                                    <p className='coupon-value'>{cpn.value}</p>

                                    <Tooltip title="Click to copy the coupon code">
                                        <Button
                                            backgroundColor="primary"
                                            style={{ color: '#1677ff', borderColor: '#1677ff' }}
                                            type="dashed"
                                            onClick={async () => {
                                                try {
                                                    await navigator.clipboard.writeText(cpn.code);
                                                    message.success("Copied to clipboard!")
                                                } catch (error) {
                                                    console.error('Failed to copy text: ', error);
                                                }
                                            }}
                                        >{cpn.code}</Button>
                                    </Tooltip>
                                </div>
                                <div>
                                    <p>{cpn.description}</p>
                                    <p className='cpn-expiry-date'>Expires at - {cpn.expires}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    )
}


function FreePlan() {

    return (
        <div className='partner-program'>
            <h2 className='pp-title'>Join our affiliate Program and get unlimited automation for upto 6 month free.</h2>

            <div className='partner-program-flex'>
                <div className='partner-card black-bg'>
                    <h1>Get 3 Month unlimited automation access free!</h1>
                    <h2>Referal Commision:</h2>
                    <ul>
                        <li>Everytime someone uses your code to subscribe to plan, you take 60% Commision on first month.</li>
                    </ul>
                    <h2>Deliverables:</h2>
                    <ul>
                        <li>1 x Instagram Reels posted to your Instagram account (Minimum 20 seconds)</li>
                    </ul>
                    <h2>Criteria:</h2>
                    <ul>
                        <li>Tag InstantDM in post and mention in caption</li>
                        <li>Add InstantDM as collaborator</li>
                        <li>Reel must remain active</li>
                        <li>No faceless content</li>

                    </ul>
                    <h2>Follower requirement:</h2>
                    <ul>
                        <li>Instagram: Minimum 25,000 followers</li>
                    </ul>
                    <h2>Bonus:</h2>
                    <ul>
                        <li>If the video reaches 1,00,000+ views within 1 weeks of posting, you will receive 6 months of unlimited automation for free.</li>
                    </ul>
                </div>
                <div className='partner-card'>
                    <h1>Get 3 Month Growth plan access free!</h1>
                    <h2>Referal Commision:</h2>
                    <ul>
                        <li>Everytime someone uses your code to subscribe to plan, you take 60% Commision on first month.</li>
                    </ul>
                    <h2>Deliverables:</h2>
                    <ul>
                        <li>1 x Instagram Reels posted to your Instagram account (Minimum 20 seconds)</li>
                    </ul>
                    <h2>Criteria:</h2>
                    <ul>
                        <li>Tag InstantDM in post and mention in caption</li>
                        <li>Add InstantDM as collaborator</li>
                        <li>Reel must remain active</li>
                        <li>No faceless content</li>
                    </ul>
                    <h2>Follower requirement:</h2>
                    <ul>
                        <li>Instagram: Minimum 8,000 followers</li>
                    </ul>
                    <h2>Bonus:</h2>
                    <ul>
                        <li>If the video reaches 50,000+ views within 1 weeks of posting, you will receive 6 months of unlimited automation plan for free.</li>
                    </ul>
                </div>
            </div>

            <h2>How to join</h2>

            <ul>Send a DM to our IG accounts <a target='_blank' href='https://www.instagram.com/code_with_ssk/'>Instagram : Code with SSK</a> or <a target='_blank' href='https://www.instagram.com/instant.dm/'>Instagram : Instant DM</a> </ul>

        </div>
    )
}



<div style={{
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "16px",
    padding: "30px 20px",
    marginBottom: "30px",
    color: "white",
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(118, 75, 162, 0.3)",
    position: "relative",
    overflow: "hidden",
    marginTop: "20px"
}}>
    <div style={{
        position: "absolute",
        top: "-50px",
        right: "-50px",
        width: "150px",
        height: "150px",
        background: "rgba(255,255,255,0.1)",
        borderRadius: "50%"
    }}></div>
    <div style={{
        position: "absolute",
        bottom: "-30px",
        left: "-30px",
        width: "100px",
        height: "100px",
        background: "rgba(255,255,255,0.1)",
        borderRadius: "50%"
    }}></div>

    <div style={{ position: "relative", zIndex: 1 }}>
        <h2 style={{ color: "white", margin: "0 0 12px 0", fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px" }}>
            🎉 New Year Sale is Ending Soon.
        </h2>
        <p style={{ color: "rgba(255,255,255,0.95)", fontSize: "16px", margin: "0 0 24px 0", fontWeight: "500" }}>
            Buy 8 Months & Get 1 Year Access. Limited Time Offer!
        </p>

        <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            background: "rgba(0,0,0,0.25)",
            padding: "8px 8px 8px 20px",
            borderRadius: "100px",
            border: "1px solid rgba(255,255,255,0.3)"
        }}>
            <span style={{ fontSize: "15px", fontWeight: 600, letterSpacing: "0.5px", textTransform: "uppercase" }}>Discount Code:</span>
            <Button
                type="primary"
                shape="round"
                icon={<CopyOutlined />}
                size="large"
                style={{
                    color: "#764ba2",
                    background: "white",
                    border: "none",
                    fontWeight: "bold",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                }}
                onClick={() => {
                    navigator.clipboard.writeText("2026");
                    message.success("Discount code '2026' copied to clipboard!");
                }}
            >
                2026
            </Button>
        </div>
    </div>
</div>





function ShowPlans(props) {

    let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    let default_currency = user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta" ? "inr" : "usd"
    const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)
    const [selectedGateway, setSelectedGateway] = useState('stripe');

    const [monthChange, setMonthChange] = useState('Yearly')

    const monthOptions = [{ "value": 'Monthly', "label": "Monthly" }, { "value": 'Yearly', "label": <Popover content={<h4 style={{ color: "white", margin: "0" }}><CrownOutlined style={{ marginRight: "10px" }} color='purple' /> Save more by going yearly</h4>} color="Purple" open={monthChange != "Yearly"}>Yearly</Popover > }];

    const [billingDetailModal, setBillingDetailModal] = useState(false)


    const [is_shopify_user, setIshopifyUser] = useState(true)

    const [storeName, setStoreName] = useState(localStorage.getItem("shopify_store_"))
    if (storeName?.includes(".myshopify.com")) {
        //    setStoreName(storeName.replace(".myshopify.com",""))

    }

    useState(() => {
        console.log("app name-=-=-=", storeName)
    }, [storeName])

    let plan_id_name = {
        free: "Free",
        566420: "Solo",
        566421: "Solo Yearly",
        566422: "Legend",
        566423: "Legend Yearly",
        428337: "Trendsetter",
        428338: "Trendsetter Yearly",
        "000003": "Legend Pro",
        "0000031": "Legend Pro Yearly",
        201: "Multiplex Lite",
        2011: "Multiplex Lite Yearly",
        202: "Multiplex Pro",
        2021: "Multiplex Pro Yearly",
        203: "Multiplex Max",
        2031: "Multiplex Max Yearly",
        204: "Multiplex Ultra",
        2041: "Multiplex Ultra Yearly",
        trendsetter_pro: "Trendsetter Pro",
        trendsetter_pro_yearly: "Trendsetter Pro Yearly",
        "legend-two-month": "Legend - 2 Months",
        "starter-quart": "Starter Plan  - 3 Months",
        "trendsetter-pro-monthly": "Trendsetter Pro",
        "trendsetter-pro-yearly": "Trendsetter Pro Yearly",
    }

    let plans = [
        // {
        //     "id": "free", "yearly_id": "free", "name": "Free", "price": "0", "inr_price": "0", "yearly_price": "0", "yearly_inr_price": "0",
        //     "description": "Launch your automation journey with 1500 free automations, giving you a head start on exploring our features and achieving your goals.",
        //     "au_count": "1,500",
        //     "features": ["1,500 Automations Monthly",  "Link Unlimited Posts", "Remove Branding", "Multiple reply comments","Normal Support"]
        // },
        // {
        //     "id": "566420", "yearly_id": "566421", "name": "Solo", "price": "$5", "inr_price": "₹399", "yearly_price": "$50", "yearly_inr_price": "₹3,999", "og_yearly_price": "$60", "og_yearly_inr_price": "₹5,388",
        //     "description": "Balanced automation and features for budget-conscious creators, maximizing value for your investment.",
        //     "au_count": "Unlimited (200 Comments / Hour)", 
        //     "features": ["Unlimited Comment to DM Automations", "Upto 200 new comment replies per hour", "Link Unlimited Posts","Link unlimited stories", "Welcome message", "Follow for link", "Reply to all comments", "Reomve Branding", "Basic Support", "Basic Dashboarf"],
        //     "comp_price": [{ "name": "Manychat", "usd": "$65", "inr": "₹5,525.00+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,634.00+" },]
        // },
        {
            "id": "566420", "yearly_id": "566421", "name": "Growth", "price": "$5", "inr_price": "₹449", "yearly_price": "$50", "yearly_inr_price": "₹4,499", "og_yearly_price": "$60", "og_yearly_inr_price": "₹5,388",
            "description": "Balanced automation and features for budget-conscious creators, maximizing value for your investment.",
            "au_count": "10,000", "features": ["10,000 Comment to DM Automations", "Upto 500 new comment replies per hour", "Link Unlimited Posts", "Link unlimited stories", "Welcome message", "Reply to all comments", "Unlimited trigger words", "Remove Branding", "Reply to any comment", "Normal Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$65", "inr": "₹5,525.00+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,634.00+" },]
        },
        // 560840
        {
            "id": "566422", "yearly_id": "566423", "name": "Legend", "price": "$8.99", "inr_price": "₹699", "yearly_price": "$89.99", "yearly_inr_price": "₹6,999", "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (500 New automation / hour)", "features": ["Unlimited Comment to DM automations", "Upto 500 new comment replies per hour", "Copy automation from previous post", "Follow for link", "Welcome message", "Link Unlimited Posts", "Link unlimited stories", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$515", "inr": "₹44,290.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },]
        },

        {
            "id": "000003", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "0000031", "name": "Legend Pro", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (1500 New automation / hour)", "features": ["Unlimited Comment to DM automations", "Upto 1500 new comment replies per hour", "Follow for link", "Welcome message", "Link Unlimited Posts", "Link unlimited stories", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$515", "inr": "₹44,290.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },],
            "recommended": true
        },

        {
            "id": "428337", "inr_monthly_regular": "₹4,499", "monthly_regular": "$50", "yearly_id": "428338", "name": "Trendsetter", "price": "$25", "inr_price": "₹1,999", "yearly_price": "$250", "yearly_inr_price": "₹19,999", "og_yearly_price": "$300", "og_yearly_inr_price": "₹23,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "Unlimited (No hourly limit) + Advanced Account Saftey", "features": ["Unlimited Comment to DM automations", "truly Unlimited", "Automate post sent to your DM", "Link unlimited stories", "Link unlimited posts", "Follow for link", "Welcome message", "Higher Rate Limit", "Auto comment reply turn-off", "Auto comment reply turn-on", "Auto Trending mode detector", "Auto trending mode activator", "Auto smart welcome message", "DM Queues", "Auto Failure detection", "Auto overload handler", "Auto smart slow down mode(Reply Delay)", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$1,235", "inr": "₹1,06,210.00+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,514.00+" },],

        },
    ]


    let multi_plans = [
        // {
        //     "id": "free", "yearly_id": "free", "name": "Free", "price": "0", "inr_price": "0", "yearly_price": "0", "yearly_inr_price": "0",
        //     "description": "Launch your automation journey with 1500 free automations, giving you a head start on exploring our features and achieving your goals.",
        //     "au_count": "1,500",
        //     "features": ["1,500 Automations Monthly",  "Link Unlimited Posts", "Remove Branding", "Multiple reply comments","Normal Support"]
        // },
        {
            "id": "201", "yearly_id": "2011", "name": "Multiplex Lite", "price": "$6", "inr_price": "₹499", "yearly_price": "$60", "yearly_inr_price": "₹4,999", "og_yearly_price": "$72", "og_yearly_inr_price": "₹5,988",
            "description": "Balanced automation and features for budget-conscious creators, maximizing value for your investment.",
            "au_count": "10,000 per Account X 2", "features": ["Maximum 2 account", "10,000 Comment to DM Automations per account", "Upto 500 new comment replies per hour", "Link Unlimited Posts", "Welcome message", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Normal Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$125", "inr": "₹10,875+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },]
        },
        // 560840
        {
            "id": "202", "yearly_id": "2021", "name": "Multiplex Pro", "price": "$8", "inr_price": "₹699", "yearly_price": "$80", "yearly_inr_price": "₹6,999", "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "15,000 per Account X 2", "features": ["Maximum 2 account", "15,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$165", "inr": "₹14,355+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },]
        },

        {
            "id": "203", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "2031", "name": "Multiplex Max", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "30,000 per Account x 3", "features": ["Maximum 3 account", "30,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$315", "inr": "₹27,405+" }, { "name": "LinkDM", "usd": "$19", "inr": "₹1,653+" },],
            "recommended": true
        },
        {
            "id": "204", "inr_monthly_regular": "₹8,699", "monthly_regular": "$99", "yearly_id": "2041", "name": "Multiplex Ultra", "price": "$69", "inr_price": "₹5999", "yearly_price": "$699", "yearly_inr_price": "₹59,999", "og_yearly_price": "$839", "og_yearly_inr_price": "₹72,000",
            "description": "Unlock limitless possibilities with unlimited automation and access to nearly every feature.",
            "au_count": "3,00,000 per Account x 6", "features": ["Maximum 6 account", "3,00,000 Comment to DM Automations per account", "Follow for link", "Welcome message", "Link Unlimited Posts", "Remove Branding", "Reply to any comment", "Multiple reply comments", "Button templates", "DM without Public Comment", "Public Comment without DM", "Access to contacts", "Slow Down Mode (Reply Delay)", "Priority Support"],
            "comp_price": [{ "name": "Manychat", "usd": "$7235", "inr": "₹6,29,000+" }, { "name": "LinkDM", "usd": "$99", "inr": "₹8,613+" },],

        },
    ]

    const getId = (id, year_id, selected) => {
        let temp_id = id
        if (selected == "Yearly") {
            temp_id = year_id
        }
        // console.log("=====", id, year_id, temp_id, selected)
        return temp_id
    }

    const PlanCard = ({ plan, price_currency }) => {

        // alert(plan.id == "566420" && default_currency !="inr")
        if (plan.id === "566420" && !showINR) {
            return
        }

        return (
            <div key={plan.id} className='price-card'>
                {/* {plan.id == props.currentPlan && <span className='current-plan'>Current Plan</span>} */}

                <div className='row' style={{ marginTop: '20px' }}>
                    <p className='plan-name'>{plan.name}  </p>
                    <div>
                        <p className='plan-price'>{showINR ? plan.inr_price : plan.price}</p>
                        {plan.inr_monthly_regular && <p className='plan-regular-price'>{showINR ? plan.inr_monthly_regular : plan.monthly_regular}</p>}
                    </div>
                </div>

                {/* {
                    (plan.id != "free" && monthChange == "Yearly") &&
                    <div className='row'>
                        <p className='plan-limit dis-price'>{showINR ? plan.yearly_inr_price : plan.yearly_price} <br /> <span className='og-price' >{showINR ? plan.og_yearly_inr_price : plan.og_yearly_price} </span></p>
                        <p className='plan-limit-desc'>Total Payable</p>
                    </div>
                } */}
                <div className='row'>
                    <p className='plan-limit'>{plan.au_count}</p>
                    <p className='plan-limit-desc'>Automation monthly</p>
                </div>

                {/* { <p className='plan-description'>{plan.description}</p>} */}


                {

                    <Card
                        style={{ marginTop: '20px', borderRadius: '12px', border: '1px solid #e0e0e0' }}
                        size="small"
                        title={<span style={{ fontSize: '14px', fontWeight: '600' }}>Select Payment Method</span>}
                    >
                        <Radio.Group
                            onChange={(e) => setSelectedGateway(e.target.value)}
                            value={selectedGateway}
                            style={{ width: '100%' }}
                        >
                            <Flex vertical gap="small">
                                <Radio value="stripe">
                                    <Flex align="center" gap="small">
                                        <span>Stripe</span>
                                    </Flex>
                                </Radio>
                                <Radio value="dodo">
                                    <Flex align="center" gap="small">
                                        <span>Dodo Payments</span>
                                    </Flex>
                                </Radio>
                            </Flex>
                        </Radio.Group>
                    </Card>
                }
                <Button size='large' type='default'
                    onClick={() => {


                        createPaymentLink(monthChange == "Yearly" ? plan.yearly_id :
                            plan.id, default_currency, props.messageApi, props.setPaymentLinkLoading, props.setPaymentLinkData, showINR ? "razorpay" : selectedGateway)

                        let user_detail = JSON.parse(localStorage.getItem("userData"))
                        let igid = localStorage.getItem("ig_id")

                        const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
                        const CHAT_ID = '776956029';
                        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                        let tele_message = `[TRYING TO SUBSCRIBE] - user ${user_detail.emailid}  - tried subscription for - ${plan.name}-${monthChange} , IG ID = ${igid} , user id = ${user_detail.user_id} , currency = ${showINR}`
                        let data = {
                            chat_id: CHAT_ID,
                            text: tele_message
                        };


                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(data)
                        })
                            .then(response => response.json())
                            .then(data => {
                                // console.log('Message sent successfully:', data);
                            })
                            .catch(error => {
                                console.error('Error sending message:', error);
                            });

                    }}

                    style={{
                        width: '90%', margin: '0 auto', marginTop: '20px',
                        borderRadius: '4px'
                    }}> {plan.id == props.currentPlan ? "Current Plan" : "Upgrade to this plan"}</Button>

                <Divider />

                {
                    plan.comp_price != undefined && plan.comp_price.map((comp, index) =>

                        <Alert
                            message={`Same Plan Cost ${showINR ? comp.inr : comp.usd} in ${comp.name} every month.`}
                            type="warning"
                            title={`${comp.name} Cost ${showINR ? comp.inr : comp.usd}`}
                            style={{ marginTop: '20px' }} />

                    )
                }
                <Divider />

                {
                    plan.features.map((feature) => <div className='feature'> ✓ {feature} </div>)
                }
            </div>
        )
    }

    const [selectedCategory, setSelectedCategory] = useState([...plans])

    let tags = {

    }
    const planFeatures = [{ title: "Automation Credits", tag: "", description: "", growth: "Unlimited", legend: "Unlimited", legend_pro: "Unlimited", trendsetter: "Unlimited", trendsetter_pro: "Unlimited" },
    { title: "Platform", tag: "", description: "", growth: "Insta Only", legend: "Insta Only", legend_pro: "Insta + FB", trendsetter: "Insta + FB", trendsetter_pro: "Insta + FB" },

    { title: "Hourly Limit", tag: "", description: "", growth: "100 / Hour", legend: "400 / Hour", legend_pro: "800 / Hour", trendsetter: "2,000 / Hour", trendsetter_pro: "Unlimited" },
    { title: "Post Automation", tag: "", description: "", growth: "✅", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Story Automation", tag: "", description: "", growth: "❌", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Post/Story Automated limit", tag: "", description: "", growth: "25", legend: "Unlimited", legend_pro: "Unlimited", trendsetter: "Unlimited", trendsetter_pro: "Unlimited" },
    { title: "Next Post Automation", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Active Next Post Automation Limit", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "10", trendsetter: "25", trendsetter_pro: "Unlimited" },
    { title: "DM Automation", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Trigger Word limit", tag: "", description: "", growth: "3", legend: "Unlimited", legend_pro: "Unlimited", trendsetter: "Unlimited", trendsetter_pro: "Unlimited" },
    { title: "Reply to all comments", tag: "", description: "", growth: "❌", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "AI Comment Reply", tag: "", description: "", growth: "❌", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Trigger Post shared to DM", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Button Templates", tag: "", description: "", growth: "✅", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Button Limits", tag: "", description: "", growth: "1", legend: "2", legend_pro: "3", trendsetter: "3", trendsetter_pro: "Maximum allowed by instagran" },
    { title: "Product Templates", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Copy Automation", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Follow for link", tag: "", description: "", growth: "✅", legend: "✅", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Follow for link - Open Profile button", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Reply Delay", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Flow Editor", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Automatic Followup", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Access to contacts", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Viral Mode", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Dashboard", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "Basic", trendsetter: "Advanced", trendsetter_pro: "Advanced" },
    { title: "Link Open Analytics", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "✅", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "DM Queues", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Over Load handler", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Smart Slowdown Mode", tag: "", description: "", growth: "❌", legend: "❌", legend_pro: "❌", trendsetter: "✅", trendsetter_pro: "✅" },
    { title: "Account Saftey", tag: "", description: "", growth: "Regular", legend: "Regular", legend_pro: "Regular", trendsetter: "Advanced", trendsetter_pro: "Most Secured" },
    { title: "Support", tag: "", description: "", growth: "Regular", legend: "Regular", legend_pro: "Regular", trendsetter: "Email + Insta", trendsetter_pro: "Email + Insta + Whatsapp" },
        // { title :"ADs on platform" , tag:"" , description:"" , growth : "Might Contains Ads" , legend : "No Ads" , legend_pro: "No Ads" , trendsetter: "No Ads" , trendsetter_pro: "No Ads"},
    ]

    const planTableColumns = [
        {
            title: 'Features',
            render: (_, record) => {

                return (
                    <p>{record.title}</p>
                )
            },

            key: 'features',
            maxWidth: '100px',
        },
        // {

        //     title: 'Starter',
        //         render: (_, record) => (
        //         <>
        //         {record.growth} 
        //         </>
        //         ),

        //     key: 'growth',
        // },
        ...(showINR
            ? [{

                title: 'Legend',
                render: (_, record) => (
                    <>
                        {record.legend}
                    </>
                ),

                key: 'legend',
            }] : []),
        {

            title: 'Legend Pro',
            render: (_, record) => (
                <>
                    {record.legend_pro}
                </>
            ),

            key: 'legend_pro',
        },
        {

            title: 'Trendsetter',
            render: (_, record) => (
                <>
                    {record.trendsetter}
                </>
            ),

            key: 'trendsetter',
        },
        {

            title: 'Trendsetter Pro',
            render: (_, record) => (
                <>
                    {record.trendsetter_pro}
                </>
            ),

            key: 'trendsetter',
        },

    ]

    const [showMonthlyPopup, setShowMontlyPopup] = useState()
    console.log("Legend plan", props?.userPlan?.data?.show_legend_plan);


    const planNames = [
        // { key: "growth", label: "Starter", 
        // "id": "566420", "yearly_id": "566421", "name": "Starter", 
        // "price": "$1", "inr_price": "₹99", "yearly_price": "$12",
        // "yearly_inr_price": "₹1099", "og_yearly_price": "$60", "og_yearly_inr_price": "₹5,388",
        // "quarterly":true, "yearly":false
        // },
        // { key: "growth", label: "Growth", 
        // "id": "566420", "yearly_id": "566421", "name": "Growth", 
        // "price": "$5", "inr_price": "₹449", "yearly_price": "$50",
        // "yearly_inr_price": "₹4,499", "og_yearly_price": "$60", "og_yearly_inr_price": "₹5,388",
        // "quarterly":true, "yearly":false
        // },
        // { key: "growth", label: "Starter",
        //     // "quarterly":true,
        //     "billing":"Billed Quarterly",
        //     "id": "starter-quart", "yearly_id": "starter-year", "name": "Starter", "price": "$2.99",
        //      "inr_price": "₹299", "yearly_price": "$29.99", "yearly_inr_price": "₹2999",
        //      "yearly_month_price": "$2.99", "yearly_month_inr_price": "₹299",
        //     //  "yearly_month_price_og": "$7.49", "yearly_month_inr_price_og": "₹582",
        //     "custom_billing_inr":"₹897",
        //     "custom_billing_usd":"$8.97",
        //     "show_monthly_sugesstion":true,
        //     "monthly_id":"starter-one",
        //     "monthly_inr":"₹449",
        //     "monthly_usd":"$5",
        //      "inr_monthly_regular": "₹700", "monthly_regular": "$7.99",
        //      "og_yearly_price": "$95.99", "og_yearly_inr_price": "₹7000",
        //      "includes":["Unlimited Automation (100 / Hour)", "25 Posts allowed", "3 Trigger word limit", "Comment to DM Automation","Follow for link","Button Template","Remove Branding",],
        //      "notIncludes":[ "No Reply to all comments", "No Flow Editor", "No Product Templates (Send 30 links in single message)","No Link Open Analytics","No next post automation",],
        //      icon: <ExperimentOutlined style={{color:"purple"}} />,

        // },
        ...(showINR && props?.userPlan?.data?.show_legend_plan
            ? [{
                key: "legend", label: "Legend",
                "billing": "Billied 2 Months",
                "custom_billing_inr": "₹1,398",
                "custom_billing_usd": "$17.98",
                "show_monthly_sugesstion": true,
                "id": "legend-two-month", "yearly_id": "566423", "name": "Legend", "price": "$8.99",
                "inr_price": "₹699", "yearly_price": "$89.99", "yearly_inr_price": "₹6,999",
                "yearly_month_price": "$7.49", "yearly_month_inr_price": "₹582",
                "inr_monthly_regular": "₹1,000", "monthly_regular": "$12",
                "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
                "includes": ["Unlimited Automation (400 / Hour)", "Link Unlimited Posts & Stories", "Follow for link", "Reply to all comments", "Remove Branding", "Button Templates"],
                "notIncludes": ["No Flow Editor", "No Product Templates (Send 30 links in single message)", "No Link Open Analytics", "No next post automation",],
                icon: <RiseOutlined style={{ color: "purple" }} />,

            }] : []),
        {
            key: "legend_pro", label: "Legend Pro",
            icon: <DashboardOutlined style={{ color: "purple" }} />,
            "id": "000003", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "0000031", "name": "Legend Pro", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
            "yearly_month_price": "$9.99", "yearly_month_inr_price": "₹833",
            "billing": "Billed Montly",
            "starting": true,
            "includes": ["Unlimited Automation (800 / Hour)", "Facebook Automation", "Link Unlimited Posts & Stories", "Reply to all comments", "10 Next Post Automation", "DM Automation basic", "Flow editor basic", "Basic Dashboard"],
            "notIncludes": ["No Product Templates (Send 30 links in single message)", "No Re-run Automation", "No Over Load handler", "No Link Open Analytics", "No Boosted reels automation"]
        },
        {
            key: "trendsetter", label: "Trendsetter",
            "icon": <FireFilled style={{ color: 'red' }} />,
            "priceDrop": true,
            "recommended": true,

            "billing": "Billed Montly",
            "yearly_month_price": "$24.99", "yearly_month_inr_price": "₹1,666",
            "id": "428337", "inr_monthly_regular": "₹4,499", "monthly_regular": "$50", "yearly_id": "428338", "name": "Trendsetter", "price": "$29.99", "inr_price": "₹1,999", "yearly_price": "$250", "yearly_inr_price": "₹19,999", "og_yearly_price": "$300", "og_yearly_inr_price": "₹23,988",
            "includes": ["Unlimited Automation (2000 / Hour)", "Boosted reels automation", "Everything from legend pro", <p>Automate Post shared to DM<Tag color='green' icon={<FireOutlined />} >Share increase reaches</Tag></p>, "Product Templates (Send 30 links in single message)", "DM Automation", "Flow editor", "Dashboard", "Link Open Analytics", "Viral Mode activator"],
            "notIncludes": ["No Re-run Automation"]
        },
        {
            key: "trendsetter_pro", label: "Trendsetter Pro",
            secured: true,
            "yearly_month_price": "$49.99", "yearly_month_inr_price": "₹4,165",
            "icon": <SafetyOutlined style={{ color: "green" }} />,
            "billing": "Billed Montly",
            "id": "trendsetter-pro-monthly", "yearly_id": "trendsetter-pro-yearly", "inr_monthly_regular": "₹14,499", "monthly_regular": "$150", "name": "Trendsetter Pro", "price": "$59.99", "inr_price": "₹4,999", "yearly_price": "$250", "yearly_inr_price": "₹19,999", "og_yearly_price": "$300", "og_yearly_inr_price": "₹23,988",
            "includes": ["Access to all features with truly unlimited", "Truly Unlimited", "Unlimited Boosted reels automation", "Advanced Account Saftey", <p>Re-run Automation <Tag color='green'>Coming soon</Tag></p>, "Whatsapp Support", "Advanced Dashboard", "Overload handler"],
            // "notIncludes":["No Over Load handler", "No Link Open Analytics", "Smart Slowdown Mode","Whatsapp Support"]
        }
    ];

    let free_plan = ["1,500 Automations Monthly", "Link Unlimited Posts", "Powered by InstantDM", "Multiple reply comments", "Normal Support", "Upto 500 new comment replies per hour"]


    function createPaymentLinkFunc(plan) {
        createPaymentLink(monthChange == "Yearly" ? plan.yearly_id :
            plan.id, default_currency, props.messageApi, props.setPaymentLinkLoading, props.setPaymentLinkData, showINR ? "razorpay" : selectedGateway)
        let user_detail = JSON.parse(localStorage.getItem("userData"))
        let igid = localStorage.getItem("ig_id")

        const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
        const CHAT_ID = '776956029';
        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `[TRYING TO SUBSCRIBE] - user ${user_detail.emailid}  - tried subscription for - ${plan.name}-${monthChange} , IG ID = ${igid} , user id = ${user_detail.user_id} , currency = ${showINR}`
        let data = {
            chat_id: CHAT_ID,
            text: tele_message
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Message sent successfully:', data);
            })
            .catch(error => {
                console.error('Error sending message:', error);
            });



    }


    if (storeName) {
        return (
            <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", alignItems: "flex-start", justifyItems: "center" }}>

                <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: 10, justifyContent: "center", flexWrap: "wrap", marginBottom: 20, marginTop: "20px" }}>

                    {[



                        {
                            key: "free", label: "Free",
                            "billing": "Billied 2 Months",
                            "custom_billing_inr": "₹0",
                            "custom_billing_usd": "$0",
                            "show_monthly_sugesstion": false,
                            "id": "free", "yearly_id": "free", "name": "Legend", "price": "free",
                            "inr_price": "free", "yearly_price": "free", "yearly_inr_price": "free",
                            "yearly_month_price": "free", "yearly_month_inr_price": "free",
                            "inr_monthly_regular": "free", "monthly_regular": "free",
                            "og_yearly_price": "free", "og_yearly_inr_price": "free",
                            "includes": ["Unlimited Automation (400 / Hour)", "Link Unlimited Posts & Stories", "Follow for link", "Reply to all comments", "Remove Branding", "Button Templates"],
                            "notIncludes": ["No DM Automation", "No Flow Editor", "No Product Templates (Send 30 links in single message)", "No Link Open Analytics", "No next post automation",],
                            icon: <RiseOutlined style={{ color: "purple" }} />,

                        },
                        {
                            key: "legend", label: "Legend",
                            "billing": "Billied 2 Months",
                            "custom_billing_inr": "₹699",
                            "custom_billing_usd": "$8.99",
                            "show_monthly_sugesstion": true,
                            "id": "legend-two-month", "yearly_id": "566423", "name": "Legend", "price": "$8.99",
                            "inr_price": "₹699", "yearly_price": "$89.99", "yearly_inr_price": "₹6,999",
                            "yearly_month_price": "$7.49", "yearly_month_inr_price": "₹582",
                            "inr_monthly_regular": "₹1,000", "monthly_regular": "$12",
                            "og_yearly_price": "$96", "og_yearly_inr_price": "₹8,388",
                            "includes": ["Unlimited Automation (400 / Hour)", "Link Unlimited Posts & Stories", "Follow for link", "Reply to all comments", "Remove Branding", "Button Templates"],
                            "notIncludes": ["No DM Automation", "No Flow Editor", "No Product Templates (Send 30 links in single message)", "No Link Open Analytics", "No next post automation",],
                            icon: <RiseOutlined style={{ color: "purple" }} />,

                        },
                        {
                            key: "legend_pro", label: "Legend Pro",
                            icon: <DashboardOutlined style={{ color: "purple" }} />,
                            "id": "000003", "inr_monthly_regular": "₹1,499", "monthly_regular": "$18", "yearly_id": "0000031", "name": "Legend Pro", "price": "$12", "inr_price": "₹999", "yearly_price": "$120", "yearly_inr_price": "₹9,999", "og_yearly_price": "$144", "og_yearly_inr_price": "11,988",
                            "yearly_month_price": "$9.99", "yearly_month_inr_price": "₹833",
                            "billing": "Billed Montly",
                            "includes": ["Unlimited Automation (800 / Hour)", "Link Unlimited Posts & Stories", "Reply to all comments", "10 Next Post Automation", "DM Automation basic", "Flow editor basic", "Basic Dashboard"],
                            "notIncludes": ["No Product Templates (Send 30 links in single message)", "No Re-run Automation", "No Over Load handler", "No Link Open Analytics", "No Boosted reels automation"]
                        },
                        {
                            key: "trendsetter", label: "Trendsetter",
                            "icon": <FireFilled style={{ color: 'red' }} />,
                            "priceDrop": true,
                            "recommended": true,

                            "billing": "Billed Montly",
                            "yearly_month_price": "$24.99", "yearly_month_inr_price": "₹1,666",
                            "id": "428337", "inr_monthly_regular": "₹4,499", "monthly_regular": "$50", "yearly_id": "428338", "name": "Trendsetter", "price": "$29.99", "inr_price": "₹1,999", "yearly_price": "$250", "yearly_inr_price": "₹19,999", "og_yearly_price": "$300", "og_yearly_inr_price": "₹23,988",
                            "includes": ["Unlimited Automation (2000 / Hour)", "Boosted reels automation", "Everything from legend pro", <p>Automate Post shared to DM<Tag color='green' icon={<FireOutlined />} >Share increase reaches</Tag></p>, "Product Templates (Send 30 links in single message)", "DM Automation", "Flow editor", "Dashboard", "Link Open Analytics", "Viral Mode activator"],
                            "notIncludes": ["No Re-run Automation"]
                        },


                    ].reverse().map((plan, idx) => (
                        <div key={idx} style={{
                            background: "#fff",
                            borderRadius: 12,
                            marginBottom: 18,
                            // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                            backgroundColor: "white",
                            padding: "16px 14px",
                            width: "280px",
                            cursor: "pointer",
                            border: "1px solid #E8EAED"
                        }}>
                            {/* <Flex align="center" justify="space-between"> */}
                            <div style={{ position: "relative" }} className={plan?.recommended ? "recommended-plan" : plan?.secured ? "secured-plan" : "regular-plan"}>
                                {plan?.priceDrop && <Tag icon={<FireFilled />} color="orange" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }}>Best For shops</Tag>}

                                {plan?.starting && <Tag color="geekblue" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }}>Best for starting</Tag>}
                                {plan?.secured && <Tag icon={<SafetyOutlined />} color="green" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }} size="large">Best for creators with 100K+ Followers</Tag>}
                                {/* { plan?.quarterly && <Tag color='magenta' style={{position:"absolute", top:"-10px", right:"-10px", fontSize:"14px"}}>Billed Quarterly</Tag> } */}
                                <div style={{ display: "flex", width: "50px", height: "50px", marginBottom: "6px", alignItems: "center", justifyContent: "center", backgroundColor: "white", borderRadius: "10px", border: "1px solid #E8EAED" }}>
                                    {plan?.icon && <span style={{ fontSize: "36px", fontWeight: "600" }}>{plan.icon}</span>}
                                </div>
                                <h2 style={{ margin: 0, marginBottom: "10px" }}>{plan.label}</h2>
                                {/* <Flex align='flex-start' justify='flex-start' vertical gap="0">  */}


                                <h4 style={{ margin: 0 }}> <span className='offer-price'> {plan.price}</span> / Month</h4>
                                <h4 className='og-price' style={{ margin: 0, fontSize: "14px", }}> {plan.monthly_regular}/ Month</h4>

                                {/* {  monthChange != "Yearly" ? plan.billing && <p style={{margin:"0", opacity:".6"}}>{plan.billing}</p> : <p style={{margin:"0", opacity:".6"}}>Billed Yearly</p> } */}
                                <Flex align='center' justify='center' vertical gap="0" style={{ marginTop: "10px" }}>
                                    <Button color={'primart'} style={{ margin: "10px auto", backgroundColor: "white", color: "black", fontWeight: plan?.recommended ? "500" : "500" }} variant={'outlined'} block size='large'

                                        href={`https://admin.shopify.com/store/${storeName}/charges/instantdm/pricing_plans`}
                                    >Upgrade to this plan</Button>
                                </Flex>
                            </div>
                            {/* {plan?.includes?.map((item, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                        <CheckCircleOutlined style={{ color: "#4f8cff", marginRight: "8px" }} />
                                        <span style={{ fontSize: "14px", color: "#222" }}>{item}</span>
                                    </div>
                                ))}
                                {plan?.notIncludes?.map((item, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                        <CloseCircleOutlined style={{ color: "#ff4d4f", marginRight: "8px" }} />
                                        <span style={{ fontSize: "14px", color: "#222" }}>{item}</span>
                                    </div>
                                ))} */}
                            {/* </Flex> */}
                            {/* </Flex> */}

                        </div>
                    ))}


                </div>
                <p style={{ margin: "auto" }}>Your subscription will be managed by shopify.. click to to check pricing shopify admin page.</p>


            </div>
        )
    }
    console.log("-=-=-=-=", props.userPlan)

    return (

        <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px" }}>
            <div style={{ padding: "0 20px" }}>
                <NewYearSaleBanner />
            </div>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <h2>InstantDM Pricing</h2>
                    {default_currency != "usd" && <p className='price-inr'><Switch value={showINR} checkedChildren="₹" unCheckedChildren="$" onChange={() => setShowINR(!showINR)} /> </p>}
                </div>
                {props?.userPlan != undefined &&
                    <Card
                        title="Subscription Details"
                        bordered={false}
                        style={{
                            maxWidth: 600,
                            margin: "0 auto",
                            borderRadius: 12,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            marginBottom: "20px"
                        }}
                    >
                        <Descriptions column={1} bordered size="middle">
                            {/* { props?.userUsage?.automation_setting?.reason_notify?.title && <Descriptions.Item label="Automation Status">
                        
                            {props?.userUsage?.automation_setting?.reason_notify?.title}
                        
                        </Descriptions.Item> } */}
                            <Descriptions.Item label="Plan">
                                <Tag color="blue">{plan_id_name[props?.userPlan?.data?.plan_details?.id] || "N/A"}</Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="Monthly Usage">
                                {
                                    props?.userUsage?.data?.monthly_count || "Loading"
                                }
                            </Descriptions.Item>
                            <Descriptions.Item label="Trending Mode">
                                {
                                    props?.userUsage?.automation_setting?.trending_mode?.activated == true ? "Activated" : "NA"
                                }
                            </Descriptions.Item>
                            <Descriptions.Item label="Plan Renewal Date">
                                {props?.userPlan?.data?.plan_renew_date || "—"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Credits">
                                {/* <Progress
                            percent={Math.min((props?.userPlan?.data?.plan_credits / 1000) * 100, 100)} // adjust denominator for your max credits
                            showInfo
                        /> */}
                                <span>{props?.userPlan?.data?.plan_credits || 0} credits</span>
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                {props?.userPlan?.data?.sub_status === "active" ? (
                                    <Tag icon={<CheckCircleOutlined />} color="success">
                                        Active
                                    </Tag>
                                ) : (
                                    <Tag icon={<CloseCircleOutlined />} color="error">
                                        Inactive
                                    </Tag>
                                )}
                            </Descriptions.Item>


                        </Descriptions>
                    </Card>
                }
            </div>

            <div className='mobile' style={{ width: "100%", display: "flex", flexDirection: "column", gap: 20 }}>
                {planFeatures.map((feature, idx) => (
                    <div key={idx} style={{
                        background: "#fff",
                        borderRadius: 12,
                        margin: "10px",
                        marginBottom: 18,
                        // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        backgroundColor: "whitesmoke",
                        border: "1px solid rgba(0,0,0,.2)",
                        padding: "16px 14px"
                    }}>
                        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10 }}>{feature.title}</div>
                        <div className='white-bg-border' style={{ display: "flex", flexDirection: "column", gap: 10, justifyContent: "space-between", flexWrap: "wrap" }}>
                            {planNames.reverse().map(plan => (
                                <div key={plan.key} style={{
                                    // flex: 1,
                                    textAlign: "left",

                                    borderRadius: 8,
                                    padding: "10px 0",
                                    margin: "0 2px",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    color: "#4f8cff",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",


                                }}>
                                    <div style={{ fontSize: 12, color: "#222", marginBottom: 4 }}>{plan.label}</div>
                                    <div style={{ fontSize: 14, textAlign: "right" }}>{feature[plan.key]}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div>
                <div style={{ width: '100%', display: 'flex', "gap": "20px", flexDirection: "column", 'alignItems': 'center', justifyContent: 'center', marginBottom: '10px' }}>



                    <Radio.Group
                        options={monthOptions}
                        onChange={({ target: { value } }) => setMonthChange(value)}
                        value={monthChange}
                        optionType="button"
                        buttonStyle="solid"
                    />

                </div>


            </div>


            <div style={{ display: "flex", flexDirection: "row", gap: 10, justifyContent: "center", flexWrap: "wrap", marginBottom: 20 }}>

                {planNames.reverse().map((plan, idx) => (
                    <div key={idx} style={{
                        background: "#fff",
                        borderRadius: 12,
                        marginBottom: 18,
                        // boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        backgroundColor: "white",
                        padding: "16px 14px",
                        width: "280px",
                        cursor: "pointer",
                        border: "1px solid #E8EAED"
                    }}>
                        {/* <Flex align="center" justify="space-between"> */}
                        <div style={{ position: "relative" }} className={plan?.recommended ? "recommended-plan" : plan?.secured ? "secured-plan" : "regular-plan"}>
                            {plan?.priceDrop && <Tag icon={<FireFilled />} color="orange" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }}>Best for shops & stores</Tag>}

                            {plan?.starting && <Tag color="geekblue" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }}>Best For starting</Tag>}
                            {plan?.secured && <Tag icon={<SafetyOutlined />} color="green" style={{ position: "absolute", top: "-10px", right: "-10px", fontSize: "14px" }} size="large">Best for creators with 50K+ Followers</Tag>}
                            {/* { plan?.quarterly && <Tag color='magenta' style={{position:"absolute", top:"-10px", right:"-10px", fontSize:"14px"}}>Billed Quarterly</Tag> } */}
                            <div style={{ display: "flex", width: "50px", height: "50px", marginBottom: "6px", alignItems: "center", justifyContent: "center", backgroundColor: "white", borderRadius: "10px", border: "1px solid #E8EAED" }}>
                                {plan?.icon && <span style={{ fontSize: "36px", fontWeight: "600" }}>{plan.icon}</span>}
                            </div>
                            <h2 style={{ margin: 0, marginBottom: "10px" }}>{plan.label}</h2>
                            {/* <Flex align='flex-start' justify='flex-start' vertical gap="0">  */}


                            <h4 style={{ margin: 0 }}> <span className='offer-price'> {monthChange != "Yearly" ? showINR ? plan.inr_price : plan.price : showINR ? plan.yearly_month_inr_price : plan.yearly_month_price}</span> / Month</h4>
                            <h4 className='og-price' style={{ margin: 0, fontSize: "14px", }}> {showINR ? plan.inr_monthly_regular : plan.monthly_regular}/ Month</h4>

                            {monthChange == "Yearly" && (
                                <div style={{ marginTop: "8px", background: "linear-gradient(90deg, #fff1f0 0%, #fffbe6 100%)", border: "1px dashed #ffa39e", padding: "6px", borderRadius: "6px", fontSize: "12px", color: "#d4380d", textAlign: "center" }}>
                                    <div>Use code <span style={{ fontWeight: "bold", background: "#fff", padding: "0 4px", borderRadius: "3px", border: "1px solid #ffccc7" }}>2026</span></div>
                                    <div style={{ fontWeight: "600", marginTop: "2px" }}>Pay for 8 months, Get 1 Year!</div>
                                </div>
                            )}


                            {monthChange != "Yearly" ? plan.billing && <p style={{ margin: "0", opacity: ".6" }}>{plan.billing}</p> : <p style={{ margin: "0", opacity: ".6" }}>Billed Yearly</p>}
                            <Flex align='center' justify='center' vertical gap="0" style={{ marginTop: "10px" }}>
                                <Button color={'primart'} style={{ margin: "10px auto", backgroundColor: "white", color: "black", fontWeight: plan?.recommended ? "500" : "500" }} variant={'outlined'} block size='large'

                                    onClick={() => {

                                        if (plan?.show_monthly_sugesstion && monthChange != "Yearly") {

                                            setShowMontlyPopup(plan)
                                            return

                                        }
                                        createPaymentLinkFunc(plan)

                                    }}
                                >Upgrade to this plan</Button>
                            </Flex>
                        </div>
                        {plan?.includes?.map((item, index) => (
                            <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                <CheckCircleOutlined style={{ color: "#4f8cff", marginRight: "8px" }} />
                                <span style={{ fontSize: "14px", color: "#222" }}>{item}</span>
                            </div>
                        ))}
                        {plan?.notIncludes?.map((item, index) => (
                            <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                <CloseCircleOutlined style={{ color: "#ff4d4f", marginRight: "8px" }} />
                                <span style={{ fontSize: "14px", color: "#222" }}>{item}</span>
                            </div>
                        ))}
                        {/* </Flex> */}
                        {/* </Flex> */}

                    </div>
                ))}


            </div>
            <div className='plans-list' style={{ position: "relative" }}>
                {/* 
                {
                    selectedCategory.map((plan) =>

                        
                        <PlanCard plan={plan} price_currency={default_currency} />

                    )
                } */}
                {/* <Tag color="green" icon={<RightCircleFilled />} style={{position:"absolute" , right:"0px" , top:"-30px"}}>Scroll</Tag> */}
                <Table className='desktop white-bg-border' dataSource={planFeatures} columns={planTableColumns} style={{ width: "80%", margin: "auto" }}
                    pagination={false}
                />


                <div>
                </div>
            </div>

            {/* <div>
                <Alert
                    message={("free" == props.currentPlan || "free" == props.currentPlan) ? `Always Free Plan (Current Plan)` : "Always Free Plan"}
                    description={<div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px" }}>{free_plan.map((item, index) => <p>{item},</p>)}</div>}
                    type="info"
                    showIcon
                />
            </div> */}

            {/* {
                showINR && <p style={{ color: 'rgba(0,0,0,.4' }}>*INR price may change based on usd to inr conversion rate, the payment will be collected in USD.</p>
            } */}
            {/* 
            <Modal title="Checkout" open={billingDetailModal} onCancel={() => setBillingDetailModal(false)}>
                <div style={{backgroundColor:"#f9f9f9",borderRadius:"10px", minHeight:"300px"}}>

                </div>
            </Modal> */}

            <Modal
                open={showMonthlyPopup?.show_monthly_sugesstion}
                onCancel={() => setShowMontlyPopup()}
                title="Pricing Suggestion"
                footer={null}
                style={{ "padding": "20px" }}

            >
                <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px", padding: "20px" }}>
                    <Card className='white-bg-border' style={{ padding: "0" }}>

                        <Row justify="space-between">
                            <Col>

                                <h3>{showMonthlyPopup?.billing}</h3>
                                {(() => {
                                    const { daysUntilRenewal, nextRenewalDate } = getRenewalInfo(
                                        new Date(),
                                        getMonthsFromBilling(showMonthlyPopup?.billing)
                                    );
                                    return (
                                        <h3 style={{ margin: 0, color: "green", fontWeight: "600" }}>
                                            Valid upto {nextRenewalDate} {" "}
                                            {/* <Tag color="green">After {daysUntilRenewal} days</Tag> */}
                                        </h3>
                                    );
                                })()}
                            </Col>
                            <Col>
                                <p style={{ margin: 0, fontWeight: 500 }}>Price</p>
                                <p style={{ margin: 0 }}>
                                    {showINR
                                        ? `${showMonthlyPopup?.inr_price}`
                                        : `${showMonthlyPopup?.price}`} / Month
                                </p>
                            </Col>
                        </Row>
                        <Row justify="space-between">
                            <h3 style={{ opacity: .6, fontWeight: "500" }}>To make things more affordable for you, this plan is {showMonthlyPopup?.billing}. Hope that works for you!</h3>

                        </Row>
                        <Row justify="start" style={{ marginTop: 8 }}>
                            <Col>

                            </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                            {(() => {
                                const { daysUntilRenewal, nextRenewalDate } = getRenewalInfo(
                                    new Date(),
                                    getMonthsFromBilling(showMonthlyPopup?.billing)
                                );
                                let display_price = showINR
                                    ? showMonthlyPopup?.custom_billing_inr
                                    : showMonthlyPopup?.custom_billing_usd

                                { splitAmountPerDay(display_price, daysUntilRenewal) }

                                return <Button className='shake-for-5s' onClick={() => createPaymentLinkFunc(showMonthlyPopup)} style={{ marginTop: "20px" }} color="purple" variant="solid" block>Pay {display_price} for {daysUntilRenewal} days</Button>
                            })()}

                        </Row>
                    </Card>


                    {/* <Card style={{ marginTop: 16 }}>
                        <Row justify="space-between">
                        <Col>
                            <p style={{ margin: 0, fontWeight: 500 }}>Billed Monthly</p>

                        </Col>
                        <Col>
                            <p style={{ margin: 0, fontWeight: 500 }}>Total Price</p>
                            <p style={{ margin: 0 }}>
                            {showINR
                                ? `${showMonthlyPopup?.monthly_inr}`
                                : `${showMonthlyPopup?.monthly_usd}`} / Month
                            </p>
                        </Col>

                        </Row>
                        <Row>
                        <Col>
                            {(() => {
                            const { daysUntilRenewal, nextRenewalDate } = getRenewalInfo(new Date(), 1);
                            return (
                                <>
                                <p style={{ margin: 0 }}>
                                Next Billing on {" "}
                                <Tag color="orange">{daysUntilRenewal} days</Tag> ({nextRenewalDate})
                                </p>
                                </>
                            );
                            })()}
                        </Col>
                        </Row>
                    </Card> */}

                </div>
            </Modal>


        </div>

    )

}

export default ShowPlans;
